import type { CommandAction } from '../../types/CommandAction.js';
import { setup } from '@ms-cloudpack/setup-utilities';

export interface SetupOptions {
  force?: boolean;
}

/** Executor for the "setup" verb */
export const execute: CommandAction<SetupOptions> = async (params) => {
  const { config, appPath: cwd } = params;
  const { server = {} } = config;
  const { domain, https } = server;

  if (domain || https) {
    await setup({
      domain,
      shouldCreateCertificate: https === true,
      cwd,
    });
  }

  return { message: 'Setup complete.' };
};
